/** Who is going to a meet, said by name where the meet is shown (DESIGN §27.3.1). */
import { Link } from "react-router";
import type { TeamAthlete } from "../../builder/model/groups.js";
import { useModel } from "../context.js";
import { goingText } from "../model/meets.js";
import type { Meet } from "../model/types.js";
import { href } from "../paths.js";
import { FlagIcon } from "./Meets.js";

export const meetPath = (id: string) => "/meet/" + encodeURIComponent(id);

/** A meet as the flag and its name, opening it. */
export function MeetLink({ meet, className }: { meet: Meet; className?: string }) {
  return (
    <Link className={className} to={meetPath(meet.id)} aria-label={"Meet: " + meet.name} title={meet.name + (meet.place ? ", " + meet.place : "")}>
      <FlagIcon />
      <span>{meet.name}</span>
    </Link>
  );
}

/** A day's meets at the head of its panel: each meet, where, and everyone going, each name opening the athlete. */
export function DayMeets({ meets, athletes }: { meets: Meet[]; athletes: TeamAthlete[] }) {
  const model = useModel();
  const inWeek = new Set(model.athletes.map((a) => a.id));
  return (
    <>
      {meets.map((m) => {
        const going = new Set(m.people);
        const who = athletes.filter((a) => going.has(a.id));
        return (
          <section className="wk-part" key={m.id}>
            <div className="wk-part-head">
              <h3>
                <MeetLink meet={m} className="wk-meet" />
              </h3>
              <span className="k-muted">{[m.place, goingText(m.people.length)].filter(Boolean).join(" · ")}</span>
            </div>
            {who.length ? (
              <ul className="wk-going" aria-label={"Going to " + m.name}>
                {who.map((a) => (
                  <li key={a.id}>{inWeek.has(a.id) ? <Link to={href(model.monday, "athlete", a.id)}>{a.name}</Link> : a.name}</li>
                ))}
              </ul>
            ) : m.people.length ? null : (
              <p className="k-muted">Nobody going yet.</p>
            )}
          </section>
        );
      })}
    </>
  );
}
